import { render, staticRenderFns } from "./candidate-wizard-personal-questions.vue?vue&type=template&id=60efc6ff&"
import script from "./candidate-wizard-personal-questions.vue?vue&type=script&lang=js&"
export * from "./candidate-wizard-personal-questions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports